import { assign } from 'xstate';

import { hasMeasureInsurance } from '../../../helpers/measureInsurance';
import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';

export const getCartSuccess = assign(
  (
    context: ProductBuilderMachineContext,
    event: ProductBuilderMachineEvent,
  ) => {
    if (
      event.type !==
        'done.invoke.productBuilder.measureInsurance.loading:invocation[0]' &&
      event.type !== 'done.invoke.productBuilder.idle.loading:invocation[0]' &&
      event.type !== 'UPDATE_CART'
    )
      return context;
    return {
      cart: event.data,
      custom: {
        ...context.custom,
        ...(hasMeasureInsurance(event.data)
          ? { measureInsurance: 'no' }
          : { measureInsurance: undefined }),
      },
    };
  },
);
